
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find-repair-shops",
      function () {
        return require("private-next-pages/find-repair-shops.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find-repair-shops"])
      });
    }
  